export default "__VITE_ASSET__5c60a163__"